export default "__VITE_ASSET__DnTIiafO__"